export const SEGMENT_EVENT = {
  ELEMENT_IMPRESSION: 'Element Impression',
  ELEMENT_INTERACTION: 'Element Interaction',
} as const;
